<template>
    <div class=" flex items-center pl-5 pt-5 justify-center pr-4 py-5">
        <img class="w-[280px]" src="../../assets/HrisLogo.png" alt="">
    </div>
    <div class="papsi-button-container scrollbar-hide">
        <div class="w-full flex-col justify-center items-center h-[85vh] overflow-auto scrollbar-hide pb-[80px]">
            <router-link class="w-full flex justify-center items-center mb-5" to="/"><DashButton type="dashboard" :class="{active: activeSidebar === 'DASHBOARD'}" @click="activeSidebar = 'DASHBOARD'" label="DASHBOARD"/></router-link>
            <p class="text-[0.8rem] p-1 pl-10 font-medium text-[#DCDDDC] mb-2">ADMINISTRATION</p>
            
            <router-link v-if="$store.state.employee_key == 'EM00000000'"  class="w-full flex justify-center items-center mb-5" to="/about"><DashButton type="adminacc" :class="{active: activeSidebar === 'ActiveAdmin'}" @click="activeSidebar = 'ActiveAdmin'" label="Super Admin Account"/></router-link>
            <router-link v-if="accAccess" class="w-full flex justify-center items-center mb-5" to="/hris-account"><DashButton type="adminacc" :class="{active: activeSidebar === 'hrisacc'}" @click="activeSidebar = 'hrisacc'" label="HRIS Account"/></router-link>
            
            <div v-if="ancAccess" class="w-full flex flex-col items-center mb-5">
                <div class="w-full flex flex-col items-center ">
                <DashButton  :dropdown="true" type="announcement" :class="{active: activeSidebar === 'ActiveAnnounce'}" @click="activeSidebar = 'ActiveAnnounce'" label="Announcement" v-on:click="show_announcement =! show_announcement"/>
                <ul v-if="show_announcement"  class="mt-3 flex flex-col gap-3 float-left">
                    <li v-for="item in announcement" v-bind:key="item.id"  class="float-left text-sm text-[#ffff] w-[100%] "><router-link class="w-[100%] menuItem-active-link" v-bind:to="item.href">{{item.label}}</router-link></li>
                </ul>
                </div>
            </div>

            <div v-if="optAccess" class="w-full flex flex-col items-center  mb-5">
                <div class="w-full flex flex-col items-center ">
                <DashButton  :dropdown="true" type="option" :class="{active: activeSidebar === 'ActiveOption'}" @click="activeSidebar = 'ActiveOption'" label="Option Modification" v-on:click="show_option =! show_option"/>
                <ul v-if="show_option"  class="mt-3 flex flex-col gap-3 float-left">
                    <li  v-for="item in modification" v-bind:key="item.id" class="float-left text-sm text-[#ffff] w-[100%] "> <router-link class="w-[100%] menuItem-active-link " v-bind:to="item.href">{{item.label}}</router-link></li>
                </ul>
                </div>
            </div>

            <div v-if="signAccess" class="w-full flex flex-col items-center mb-5">
                <DashButton  :dropdown="true" type="sign" :class="{active: activeSidebar === 'ActiveFormsig'}" @click="activeSidebar = 'ActiveFormsig'" label="Form Signatory" v-on:click="show_request =! show_request"/>
                <ul v-if="show_request"  class="mt-3 flex flex-col gap-3 float-left">
                    <li v-for="item in signatory" v-bind:key="item.id"  class="float-left text-sm text-[#ffff] w-[100%] "> <router-link class="w-[100%] menuItem-active-link" v-bind:to="item.href">{{item.label}}</router-link></li>
                </ul>
            </div>

            <div v-if="reqAccess" class="w-full flex flex-col items-center mb-5">
                <DashButton :dropdown="true" type="request" :class="{active: activeSidebar === 'ActiveFormreq'}" @click="activeSidebar = 'ActiveFormreq'" label="Form Requests" v-on:click="show_signatory =! show_signatory"/>
                <ul v-if="show_signatory"  class="mt-3 flex flex-col gap-3 float-left">
                    <li v-for="item in request" v-bind:key="item.id" class="float-left text-sm text-[#ffff] w-[100%] "> <router-link class="w-[100%] menuItem-active-link" v-bind:to="item.href">{{item.label}}</router-link></li>
                </ul>
            </div>
            <p class="text-[0.8rem] p-1 pl-10 font-medium text-[#DCDDDC]">EMPLOYEE'S INFORMATION HUB</p>

            <router-link v-if="empAccess" class="w-full flex justify-center items-center mb-5" to="/search-employee"><DashButton type="Profile" :class="{active: activeSidebar === 'ActiveProfile'}" @click="activeSidebar = 'ActiveProfile'" label="Employee Profile"/></router-link>
            <router-link v-if="payAccess" class="w-full flex justify-center items-center mb-5" to="/payroll"><DashButton type="Payroll" :class="{active: activeSidebar === 'ActivePayroll'}" @click="activeSidebar = 'ActivePayroll'" label="Employee Payslip"/></router-link>

            <div v-if="servAccess" class="w-full flex flex-col items-center mb-5">
                <DashButton :dropdown="true" type="Services" :class="{active: activeSidebar === 'ActivePersonnel'}" @click="activeSidebar = 'ActivePersonnel'" label="Personnel Services" v-on:click="show_personnel =! show_personnel"/>
                <ul v-if="show_personnel" class="mt-3 flex flex-col gap-3 justify-start">
                    <li  v-for="item in personnel" v-bind:key="item.id" class="float-left text-sm text-[#ffff] w-[100%] "><router-link class="w-[100%] menuItem-active-link" v-bind:to="item.href">{{item.label}}</router-link></li>
                </ul>
            </div>
            <router-link v-if="poliAccess" class="w-full flex justify-center items-center mb-5" to="/policies-Procedures"><DashButton type="Procedures" :class="{active: activeSidebar === 'ActivePolicies'}" @click="activeSidebar = 'ActivePolicies'" label="Policies and Procedures"/></router-link>
        
            <!-- <router-link class="w-full flex justify-center items-center mb-5" to="/PoliciesProcedures"><DashButton type="dashboard" :class="{active: activeSidebar === 'DASHBOAqRD'}" @click="activeSidebar = 'DASHBOARD'" label="Performance Evaluation"/></router-link> -->
        </div>
</div>



</template>

<script>
import { defineComponent } from 'vue'
import DashButton from '../controls/Button/SideBarButton.vue'

export default defineComponent({
  components:{
    DashButton
  },
  data(){
    return{
        accAccess:      false,
        ancAccess:      false,
        optAccess:      false,
        signAccess:     false,
        reqAccess:      false,
        empAccess:      false,
        payAccess:      false,
        servAccess:     false,
        poliAccess:     false,
        activeSidebar:  null,
        show_div:       false,
        show_announcement: false,
        show_option: false,
        show_signatory: false,
        show_request: false,
        show_payroll: false,
        show_personnel: false,
        show_policies: false,
        show_employee: false,
        menu: [
            { 
                id: "AddProfile",
                href: "/about",
                label: "Search, Edit and Add"
            }
        ],
        announcement: [
            { 
                id: "DashboardAnnouncement",
                href: "/annoucement",
                label: "Dashboard Announcement"
            },
            {
                id: "NewsLetter",
                href: "/newsletter",
                label: "Newsletter"
            },
            // {
            //     id: "Message",
            //     href: "/message",
            //     label: "Messages"
            // }
        ],
        modification: [
            { 
                id: "Division/OfficeItem",
                href: "/division",
                label: "Division/Office Item"
            },
            {
                id: "DepartmentItem",
                href: "/department",
                label: "Department Item"
            },
            {
                id: "SectionItem",
                href: "/section",
                label: "Section Item"
            },
            {
                id: "PositionItem",
                href: "/position",
                label: "Position Item"
            }
        ],
        signatory: [
            { 
                id: "LeaveForm",
                href: "/leave-signatories",
                label: "Main Office Signatory"
            },
            { 
                id: "LeaveForm",
                href: "/pso-signatories",
                label: "Satellite Office Signatory"
            },
        ],
        request: [
            { 
                id: "LeaveRequest",
                href: "/leave-request",
                label: "Leave Requests"
            },
            {
                id: "HrRequestform",
                href: "/hr-request-form",
                label: "HR Request Forms"
            },
            {
                id: "SectionItem",
                href: "/training-requistion-request",
                label: "Training Requisition Requests"
            },
            {
                id: "ConsiderationRequest",
                href: "/consideration-request",
                label: "Consideration Requests"
            },
            {
                id: "OBRequests",
                href: "/official-business",
                label: "Official Business Requests"
            },
            // {
            //     id: "Overtime",
            //     href: "/overtime",
            //     label: "Overtime Requests"
            // },
            {
                id: "FileMaintenace",
                href: "/file-maintenance",
                label: "File Maintenance"
            }
        ],
        payroll: [
            { 
                id: "payroll",
                href: "/payroll",
                label: "Search/Edit"
            }
        ],
        employee: [
            { 
                id: "employee",
                href: "/search-employee",
                label: "Search/Edit"
            },
        ],
        policy: [
            { 
                id: "/PoliciesProcedures",
                href: "/policies-procedures",
                label: "Search/Edit"
            }
        ],
        personnel: [
            { 
                id: "Job Description",
                href: "/job-description",
                label: "Job Description"
            },
            { 
                id: "Employee 201",
                href: "/employee-201",
                label: "Employee 201 Attachments"
            },
            { 
                id: "EmployeeLeaveRecord",
                href: "/employee-leave",
                label: "Employee Leave Record"
            },
        ]
    }
  },
  mounted(){
    this.verifyss()
  }, 
  methods: {
    displayDiv(){
        if(!this.show_div){
            this.show_div = true
            this.show_announcement = false
            this.show_option = false
            this.show_signatory= false
            this.show_request= false
        }
        else{
            this.show_div = false
        }
    },
    async verifyss(){
        let state = this.$store.state

        if(state.employee_key != 'EM00000000'){
            this.accAccess  =    state.access.hrisModule
            this.ancAccess  =    state.access.ancModule
            this.optAccess  =    state.access.optModule
            this.signAccess =    state.access.sigModule
            this.reqAccess  =    state.access.reqModule
            this.empAccess  =    state.access.profModule
            this.payAccess  =    state.access.payModule
            this.servAccess =    state.access.perModule
            this.poliAccess =    state.access.polModule
        }   
        else{
            this.accAccess  =    true
            this.ancAccess  =    true
            this.optAccess  =    true
            this.signAccess =    true
            this.reqAccess  =    true
            this.empAccess  =    true
            this.payAccess  =    true
            this.servAccess =    true
            this.poliAccess =    true
        }
    }
    
}
})

</script>


<style scoped>

.active{
    background-color: #CCAF12;
}
.shadow{
    box-shadow: rgba(6, 24, 44, 0.164) 0px 0px 0px 2px, rgba(6, 24, 44, 0.493) 0px 4px 6px -1px, rgba(255, 255, 255, 0.24) 0px 1px 0px inset;
 }
.scrollbar-hide::-webkit-scrollbar{
    display:none;
}

</style> 
